import { securedAxiosInstance } from "../axios";
import { toSnakeCase } from "@estaly/ui";

class ChallengesService {
  fetchIndex(storeId, { includes = [], perPage } = {}) {
    return securedAxiosInstance.get("/challenges", { params: toSnakeCase({ storeId, includes, perPage }) });
  }

  fetchPerformance(storeId, challengeId, { region = [], ownershipType = [] } = {}) {
    return securedAxiosInstance.get("/challenges/performance", {
      params: toSnakeCase({ storeId, challengeId, region, ownershipType }),
    });
  }
}

export default new ChallengesService();
